// 权限检查工具函数

/**
 * 检查用户是否有指定权限
 * @param {string} permission - 权限名称
 * @returns {boolean} - 是否有权限
 */
export function hasPermission(permission) {
  // 从localStorage获取用户权限信息
  const userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]')
  const userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]')
  
  // 如果是超级管理员，拥有所有权限
  if (userRoles.includes('super_admin')) {
    return true
  }
  
  // 检查用户是否有指定权限
  return userPermissions.includes(permission)
}

/**
 * 检查用户是否有访问指定路由的权限
 * @param {string} routePath - 路由路径
 * @returns {boolean} - 是否有权限
 */
export function hasRoutePermission(routePath) {
  // 所有用户都可以访问的页面
  const publicPages = ['/home', '/profile', '/login', '/no-permission']
  
  // 如果是公开页面，允许所有用户访问
  if (publicPages.includes(routePath)) {
    return true
  }
  
  // 路由权限映射
  const routePermissionMap = {
    '/dashboard': 'dashboard',
    '/robots': 'robots',
    '/wechat-groups': 'wechat-groups',
    '/wechat-contacts': 'wechat-contacts',
    '/messages': 'messages',
    '/ai-auto': 'ai-auto',
    '/task': 'task',
    '/video-tutorials': 'video-tutorials',
    '/api-doc': 'api-doc',
    '/api-debug': 'api-debug',
    '/user-management': 'user-management',
    '/role-management': 'role-management',
    '/permission-management': 'permission-management'
  }
  
  const requiredPermission = routePermissionMap[routePath]
  
  // 如果路由没有权限要求，则允许访问
  if (!requiredPermission) {
    return true
  }
  
  // 检查用户是否有权限数据
  const userPermissions = JSON.parse(localStorage.getItem('userPermissions') || '[]')
  const userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]')
  
  // 如果是超级管理员，拥有所有权限
  if (userRoles.includes('super_admin')) {
    return true
  }
  
  // 检查用户是否有指定权限
  return userPermissions.includes(requiredPermission)
}

/**
 * 获取用户权限列表
 * @returns {Array} - 权限列表
 */
export function getUserPermissions() {
  return JSON.parse(localStorage.getItem('userPermissions') || '[]')
}

/**
 * 获取用户角色列表
 * @returns {Array} - 角色列表
 */
export function getUserRoles() {
  return JSON.parse(localStorage.getItem('userRoles') || '[]')
}

/**
 * 检查用户是否已登录
 * @returns {boolean} - 是否已登录
 */
export function isLoggedIn() {
  return !!localStorage.getItem('token')
} 